import React from 'react';

export default function MemberPortal(props) {
  const id = typeof props.section.prop('servant_keeper_id') !== 'undefined' && props.section.prop('servant_keeper_id') !== '' && props.section.prop('servant_keeper_id') !== null ? props.section.prop('servant_keeper_id') : (typeof FW.store.get('site').prop('sk_web_id') !== 'undefined' ? FW.store.get('site').prop('sk_web_id') : FW.store.get('customer').get('sk_web_id'));
  return <div style={{textAlign: 'center'}}>
    <a className="btn btn-primary btn-lg"
       target="_blank"
       href={'https://www.servantkeeper.com/member-portal/' + id}>Member Portal</a>
    {/*<iframe src={'https://www.servantkeeper.com/member-portal/' + props.section.prop('servant_keeper_id')} style={{
      width: '100%',
      height: 700
    }} />*/}
  </div>;
}
